import React from 'react';
import './../index.css';

export class LevelChildren extends React.Component {

  render() {
    const children = this.props.children;
      return (
        <>
          {
            /*
            * Child button section
            */
          }
          <div>
            <table style={{ width: "100%" }}><tbody>{
              children.map(
                currentLevel =>
                  <tr key={currentLevel.index}>
                    <td key={currentLevel.index}>
                      <button className='childButton' onClick={() => this.props.onLevelClick(currentLevel.index)}>
                        {currentLevel.title}
                      </button>
                    </td>
                  </tr>
              )
            }</tbody></table>
          </div>
        </>
      );

  }


}
